import {
  SkeletonWrapper,
  SkeletonBreadcrumbs,
  SkeletonContent,
  SkeletonImage,
  SkeletonDetails,
  SkeletonInfo,
  SkeletonTitle,
  SkeletonTabs,
} from './ProductDetails.skeleton.styles';
import Skeleton from '@atoms/Skeleton/Skeleton';

interface Props {
  isPage?: boolean;
}

const ProductDetailsSkeleton = ({ isPage }: Props) => {
  return (
    <SkeletonWrapper data-testid="product-details-skeleton">
      {isPage && <SkeletonBreadcrumbs type="text" height={20} width={380} />}
      <SkeletonContent $isPage={isPage}>
        <SkeletonImage type="rect" $isPage={isPage} />
        <SkeletonDetails $isPage={isPage}>
          {!isPage && <Skeleton type="text" height={20} width={380} />}
          <SkeletonTitle type="text" width={200} height={36} $isPage={isPage} />
          <SkeletonInfo type="text" width={100} height={16} />

          <Skeleton type="button" width={180} height={44} />

          <SkeletonTabs type="rect" width="100%" $isPage={isPage} />
        </SkeletonDetails>
      </SkeletonContent>
    </SkeletonWrapper>
  );
};

export default ProductDetailsSkeleton;
